import React, { lazy } from "react";

import {
  Routes,
  Navigate,
  URLS,
  Route,
  PrivateOutlet,
} from "./shared/library/router";

const HomeScreen = lazy(() => import("./screens/public/home-screen"));
const LoginScreen = lazy(() => import("./screens/public/login-screen"));
const CreateReportScreen = lazy(
  () => import("./screens/protected/create-report-screen")
);

const CreateSuccessScreen = lazy(
  () => import("./screens/protected/create-success-screen")
);

const HistoryScreen = lazy(() => import("./screens/protected/history-screen"));

export const DefaultRoutes = () => (
  <Routes>
    <Route path={URLS.HOME} element={<HomeScreen />} />

    <Route path={URLS.CREATE} element={<PrivateOutlet />}>
      <Route path="" element={<CreateReportScreen />} />

      <Route path="success" element={<CreateSuccessScreen />} />
    </Route>

    <Route path={URLS.HISTORY} element={<PrivateOutlet />}>
      <Route path="" element={<HistoryScreen />} />

      <Route path="*" element={<Navigate to={URLS.HOME} />} />
    </Route>

    <Route path={URLS.LOGIN} element={<LoginScreen />} />

    <Route path="*" element={<Navigate to={URLS.HOME} />} />
  </Routes>
);
